import React from 'react';
import { observer } from 'mobx-react';
import { InputProps } from 'ui/base/types';
import { PasswordStore } from './password_store';
import styles from './password_input.module.css';
import Messages from './password_input_messages';

export type PasswordInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: PasswordStore;
  visibleClassName?: string;
};

export const PasswordInput = observer(({ store, visibleClassName, ...props }: PasswordInputProps) => {
  return (
    <div className={styles.container}>
      <input
        type={store.visible ? 'text' : 'password'}
        value={store.value}
        onChange={store.onChange}
        {...props}
      />
      <div className={styles.toggleContainer}>
        <button type='button' className={visibleClassName} onClick={store.toggleVisible}>
          {store.visible ? Messages.hide() : Messages.show()}
        </button>
      </div>
    </div>
  );
});
